import React from 'react';
import { CheckCircle2, XCircle, AlertCircle } from 'lucide-react';
import { Inspection } from '../types';
interface InspectionTimelineProps {
  inspections: Inspection[];
}
export function InspectionTimeline({
  inspections
}: InspectionTimelineProps) {
  return <div className="relative border-l-2 border-slate-200 ml-3 md:ml-4 space-y-8 pb-4" data-id="element-51">
      {inspections.map((inspection, index) => {
      const isLatest = index === 0;
      let StatusIcon = CheckCircle2;
      let iconColor = 'text-green-500';
      let bgColor = 'bg-green-100';
      if (inspection.status === 'Fail') {
        StatusIcon = XCircle;
        iconColor = 'text-red-500';
        bgColor = 'bg-red-100';
      } else if (inspection.status === 'Conditional Pass') {
        StatusIcon = AlertCircle;
        iconColor = 'text-amber-500';
        bgColor = 'bg-amber-100';
      }
      return <div key={inspection.id} className="relative pl-6 md:pl-8" data-id="element-52">
            <div className={`absolute -left-[11px] top-1 w-5 h-5 rounded-full border-2 border-white ${bgColor} flex items-center justify-center`} data-id="element-53">
              <div className={`w-2.5 h-2.5 rounded-full ${iconColor.replace('text-', 'bg-')}`} data-id="element-54" />
            </div>

            <div className={`bg-white rounded-xl p-4 sm:p-5 ring-1 ${isLatest ? 'ring-teal-500/30 shadow-md' : 'ring-slate-200 shadow-sm'}`} data-id="element-55">
              {isLatest && <span className="inline-block px-2 py-1 bg-teal-100 text-teal-800 text-xs font-bold rounded-md mb-3 uppercase tracking-wider" data-id="element-56">
                  Latest Inspection
                </span>}

              <div className="flex flex-wrap justify-between items-start gap-4 mb-2" data-id="element-57">
                <div data-id="element-58">
                  <h4 className="text-lg font-bold text-slate-900" data-id="element-59">
                    {new Date(inspection.date).toLocaleDateString(undefined, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                  </h4>
                  <div className="flex items-center gap-2 mt-1" data-id="element-60">
                    <StatusIcon className={`w-4 h-4 ${iconColor}`} data-id="element-61" />
                    <span className="text-sm font-medium text-slate-700" data-id="element-62">
                      {inspection.status}
                    </span>
                    <span className="text-slate-300" data-id="element-63">•</span>
                    <span className="text-sm text-slate-600" data-id="element-64">
                      Score: {inspection.score}/100
                    </span>
                  </div>
                </div>

                <div className="flex flex-col items-end" data-id="element-65">
                  <span className="text-2xl font-black text-slate-900" data-id="element-66">
                    {inspection.grade}
                  </span>
                  <span className="text-xs text-slate-500 font-medium uppercase" data-id="element-67">
                    Grade
                  </span>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-68">
                <p className="text-sm text-slate-600" data-id="element-69">
                  {inspection.violations.length === 0 ? 'No violations found during this inspection. Excellent work!' : `Found ${inspection.violations.length} violation${inspection.violations.length === 1 ? '' : 's'}.`}
                </p>
              </div>
            </div>
          </div>;
    })}
    </div>;
}